import * as React from 'react';

const Dropdown16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 12 2 6h12z" }));
Dropdown16.Size = 16;
Dropdown16.Title = "Dropdown";

export { Dropdown16 as default };
